import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getBestSellers } from '../../services/products';
import { Skeleton } from '../ui/skeleton';

const FeaturedCollections = () => {
  const { t } = useTranslation();
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCollections = async () => {
      try {
        // Use best sellers as featured collections
        const products = await getBestSellers();
        const featured = products.slice(0, 4).map((product, index) => ({
          id: product.id,
          title: product.name,
          image: product.images?.[0] || '',
          link: `/product/${product.id}`,
        }));
        setCollections(featured);
      } catch (error) {
        console.error('Error fetching featured collections:', error);
        setCollections([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCollections();
  }, []);

  if (loading) {
    return (
      <section className="py-5 sm:py-7">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-6">
            <Skeleton className="h-10 w-64 mx-auto mb-4" />
            <Skeleton className="h-6 w-96 mx-auto" />
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {[1, 2, 3, 4].map((i) => (
              <Skeleton key={i} className="aspect-square w-full rounded-lg" />
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (collections.length === 0) {
    return null;
  }

  return (
    <section className="py-5 sm:py-7">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6">
          <h2 className="text-3xl sm:text-4xl font-semibold mb-3">Öne Çıkan Koleksiyonlar</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Özel olarak seçilmiş koleksiyonlarımızı keşfedin
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {collections.map((collection) => (
            <Link
              key={collection.id}
              to={collection.link}
              className="group relative aspect-square overflow-hidden rounded-lg bg-gray-100"
            >
              {collection.image ? (
                <img
                  src={collection.image}
                  alt={collection.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              ) : (
                <div className="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
                  <span className="text-gray-500 font-medium">{collection.title}</span>
                </div>
              )}
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center">
                  <h3 className="text-white text-xl sm:text-2xl font-semibold mb-2 transform group-hover:scale-105 transition-transform">
                    {collection.title}
                  </h3>
                  <span className="inline-block text-white text-sm font-medium border-b-2 border-white pb-1 opacity-0 group-hover:opacity-100 transition-opacity">
                    {t('common.shopNow')}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedCollections;